// Public terms of service page (rendered at /terms, no auth required).
// Referenced from the Twilio A2P 10DLC campaign registration and the SMS opt-in.

const EFFECTIVE = 'July 27, 2026';

export default function TermsOfService() {
  return (
    <div className="app">
      <header className="topbar">
        <div className="brand">🦅 Eagle Ridge Outdoor Club</div>
        <a className="topbar-link" href="/">Home</a>
      </header>
      <main className="content legal">
        <div className="card">
          <h1>Terms of Service</h1>
          <p className="muted">Effective {EFFECTIVE}</p>

          <p>
            These Terms of Service ("Terms") govern your use of the Eagle Ridge
            Outdoor Club member portal at eagleridgeclub.com. By accepting an
            invitation and using the portal, you agree to these Terms.
          </p>

          <h2>Membership and accounts</h2>
          <p>
            Access to the portal is by invitation to Eagle Ridge members. You are
            responsible for keeping your account credentials secure and for the
            activity that occurs under your account. Membership benefits,
            reservations, and community boards are provided for the personal use of
            club members.
          </p>

          <h2>Acceptable use</h2>
          <ul>
            <li>Use the portal only for lawful club-related purposes.</li>
            <li>Do not post content that is unlawful, harassing, or infringes on others' rights.</li>
            <li>Do not attempt to disrupt, probe, or gain unauthorized access to the portal or other members' accounts.</li>
          </ul>

          <h2>Text messaging (SMS) program</h2>
          <p>
            Eagle Ridge offers an optional SMS program for club announcements and
            updates. Enrollment is voluntary and is not a condition of membership.
            By providing your mobile number and checking the SMS consent box, you
            agree to receive informational text messages from Eagle Ridge.
          </p>
          <ul>
            <li><strong>Message frequency varies</strong> and is expected to be a few messages per month.</li>
            <li><strong>Message and data rates may apply.</strong></li>
            <li>Reply <strong>STOP</strong> at any time to unsubscribe. Reply <strong>HELP</strong> for help.</li>
            <li>Carriers are not liable for delayed or undelivered messages.</li>
          </ul>
          <p>
            See our <a href="/privacy">Privacy Policy</a> for how we handle your
            mobile information. We do not share mobile numbers or SMS consent with
            third parties for their marketing purposes.
          </p>

          <h2>Payments</h2>
          <p>
            Membership dues and any paid offerings are processed through our
            third-party payment processor. Fees are described at the time of
            purchase.
          </p>

          <h2>Disclaimers and limitation of liability</h2>
          <p>
            The portal and club activities are provided "as is." Outdoor recreation
            involves inherent risks; participation is at your own risk. To the
            extent permitted by law, Eagle Ridge is not liable for indirect or
            incidental damages arising from use of the portal.
          </p>

          <h2>Changes to these Terms</h2>
          <p>
            We may update these Terms from time to time. Continued use of the portal
            after changes take effect constitutes acceptance of the updated Terms.
          </p>

          <h2>Contact us</h2>
          <p>
            Eagle Ridge Outdoor Club, Corinth, Kentucky —{' '}
            <a href="mailto:support@eagleridgeclub.com">support@eagleridgeclub.com</a>.
          </p>

          <p className="muted"><a href="/privacy">Privacy Policy</a> · <a href="/">Return to portal</a></p>
        </div>
      </main>
      <footer className="footer"><span>Corinth, Kentucky</span></footer>
    </div>
  );
}
